<template>
    <div class="row">
		<loading id="spinner" :active="false" :can-cancel="false" :is-full-page="true"></loading>
        <div class="col s12">
            <ul class="tabs">
                <li class="tab col s3">
                    <a href="#curriculo">
                        Currículo
                    </a>
                </li>
                <li class="tab col s3 ">
                    <a href="#artistico-cultural">
                        Artístico-Cultural
                    </a>
                </li>
                <li class="tab col s2">
                    <a href="#relatorio">
                        Relatório
                    </a>
                </li>
                <li class="tab col s2">
                    <a href="#siac">
                        Siac
                    </a>
                </li>
                <li class="tab col s2 ">
                    <a class="activate" href="#projeto">Ação</a>
                </li>
                
            </ul>
        </div>
        <div id="projeto" class="col s12">
            <avaliacao-projeto :title="this.titulo" v-if="bolsas.length" />
        </div>
        <div id="curriculo" class="col s12">
            <avaliacao-curriculo />
        </div>

        <div id="artistico-cultural" class="col s12">
            <avaliacao-artistico-cultural />
        </div>
        <div id="relatorio" class="col s12">
            <avaliacao-relatorio />
        </div>
        <div id="siac" class="col s12">
            <avaliacao-siac 
				:itens_siac_orientador="this.itens_siac_orientador"
				:nota_max_siac_orient="this.nota_max_siac_orient"/>
        </div>
        
		<div class="row">
			<center>
				<a :disabled='this.impedido == true || justificativa || impedimento == false' class="btn teal" @click="justificativa = true;"><i class="material-icons left">block</i>Declarar impedimento</a>
			</center>
			<div v-if='justificativa' class="input-field col s12 m12 l12 x12">
				<textarea name="justificativa" id="justificativa" required class="materialize-textarea" maxlength="500" data-length="500" @focus="colocarContador();" v-model='texto'></textarea>
				<label for="justificativa" class='active'>Justificativa</label>
			</div>	
			<div v-if='justificativa' class="file-field input-field col s12 m12 l6 xl6">	
				<div class="btn">
					<span>Anexo da justificativa</span>
						<input type="file" title="PDF ou imagem da justificativa" :id="'/avaliacoes-aval/impedido/' + aval.id + '/arq'" accept="application/pdf, image/*" required class="validate">
					
				</div>
				<div class="file-path-wrapper">
					<input id='arquivo' class="file-path validate" type="text" @change="validarArquivo();">
				</div>
			</div>
			<div v-if="justificativa && texto.length && arquivo" class="input-field col s12 m12 l12 x12">
				<center>
					<a :disabled='this.impedido == true' class="btn teal" :href="'/avaliacoes-aval/impedido/' + aval.id + '/' + texto" onclick="return confirmarImpedimento();"><i class="material-icons left">done</i>Enviar</a>
				</center>
			</div>
		</div>
		
    </div>
</template>

<script>
import AvaliacaoProjeto from "./../AvaliacaoProjeto.vue";
import AvaliacaoCurriculo from "./../AvaliacaoCurriculo.vue";
import AvaliacaoArtisticoCultural from "./../AvaliacaoArtisticoCultural.vue";
import AvaliacaoRelatorio from "../../pages/AvaliacaoRelatorio.vue";
import AvaliacaoSiac from "./../AvaliacaoSiac.vue";
import { mapState, mapActions } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    components: {
        AvaliacaoProjeto,
        AvaliacaoCurriculo,
        AvaliacaoArtisticoCultural,
        AvaliacaoRelatorio,
        AvaliacaoSiac,
		Loading
    },
    name: "VueAvaliacaoForm",
    props: ["avaliacao", "impedido", "impedimento", "titulo", "bolsas", "itens_siac_orientador", "nota_max_siac_orient"],
    computed: {
        ...mapState(["project"])
    },
    methods: {
        ...mapActions(["setProject", "setAvaliacao", "setBolsas"]),
		colocarContador() { 
			$("#justificativa").characterCounter();
		},
		validarArquivo() {
			if (document.getElementById('arquivo').value.length)
				this.arquivo = true;
			else 
				this.arquivo = false;
		}
		
    },
    data() {
        return {
            aval: JSON.parse(this.avaliacao),
			justificativa: false,
			texto: '',
			arquivo: false
        };
    },

    async created() {
        try {
            this.$set(this.$store.state, "project", this.aval.projeto);
            this.setProject(this.project);
            this.$set(this.project, "avaliacao", this.aval);
            this.setAvaliacao(this.project.avaliacao);
            let { data: bolsas } = await this.$http.get(
                `/api/bolsas/project/${this.project.id}`
            );
            this.$set(this.project, "bolsas", bolsas);
            this.setBolsas(this.project.bolsas);
        } catch (error) {
            console.log(error);
        }
    }
};
</script>
